import React, { useState, useEffect } from 'react';
import './css/Sidebar.css';
import sidebarLogo from './images/sidebar_logo.png'; // adjust path to match your project structure

const Sidebar = ({ isOpen, onToggle }) => {
  const [user, setUser] = useState(null);
  const [masterSubmenuOpen, setMasterSubmenuOpen] = useState(false);

  const currentPath = window.location.pathname;
  const isActive = (path) => currentPath === path;

  const masterPaths = [
    '/MasterCharacter', '/MasterAdditionalContent', '/MasterOpening',
    '/SpecialReplyPage', '/FollowUpPage',
  ];
  const masterGroupActive = masterPaths.some(isActive);

  // Get user data from localStorage
  useEffect(() => {
    const userData = JSON.parse(localStorage.getItem('user') || 'null');
    if (userData) setUser(userData);
  }, []);

  // Auto-open master submenu if a child page is active
  useEffect(() => {
    if (masterGroupActive) setMasterSubmenuOpen(true);
  }, [masterGroupActive]);

  const handleMasterToggle = () => setMasterSubmenuOpen(!masterSubmenuOpen);

  const handleLogout = async () => {
    const user = JSON.parse(localStorage.getItem('user') || '{}');
    try {
      await fetch('/api/login/logout', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ pkkey: user.pkkey }),
      });
    } catch (error) {
      console.error('Logout API error:', error);
    } finally {
      localStorage.removeItem('user');
      localStorage.removeItem('rememberToken');
      window.location.href = '/LoginPage';
    }
  };

  return (
    <div className={`sidebar ${isOpen ? 'open' : 'closed'}`}>

      {/* ── Brand header ── */}
      <div className="sidebar-header">
        <img
          src={sidebarLogo}
          alt="Ikigai ForHim"
          className="sidebar-logo"
        />
        <div className="sidebar-brand">
          <span className="sidebar-brand-name">IKIGAI FORHIM</span>
          <span className="sidebar-brand-tag">Appointment System</span>
		  <span className="sidebar-brand-tag">(Chinese Version)</span>
        </div>
      </div>

      <nav className="sidebar-nav">
		
		<a
          className={`sidebar-nav-item ${isActive('/HomePage') ? 'sidebar-nav-item-current' : ''}`}
          href="/HomePage"
        >
          A - Dashboard
        </a>
		
        {/* B - Conversation Inbox: all users */}
        <a
          className={`sidebar-nav-item ${isActive('/ChatboxPage') ? 'sidebar-nav-item-current' : ''}`}
          href="/ChatboxPage"
        >
          B - Conversation Inbox
        </a>

        {/* C - Client: type 1 & 2 */}
        {user && (user.type === 1 || user.type === 2) && (
          <a
            className={`sidebar-nav-item ${isActive('/ClientPage') ? 'sidebar-nav-item-current' : ''}`}
            href="/ClientPage"
          >
            C - Client
          </a>
        )}

        {/* D - Doctor: type 1 & 2 */}
        {user && (user.type === 1 || user.type === 2) && (
          <a
            className={`sidebar-nav-item ${isActive('/DoctorPage') ? 'sidebar-nav-item-current' : ''}`}
            href="/DoctorPage"
          >
            D - Consultant
          </a>
        )}

        {/* E - Calendar: type 1 & 2 */}
        {user && (user.type === 1 || user.type === 2) && (
          <a
            className={`sidebar-nav-item ${isActive('/CalendarPage') ? 'sidebar-nav-item-current' : ''}`}
            href="/CalendarPage"
          >
            E - Calendar
          </a>
        )}

        {/* X - Master group: type 1 & 2 */}
        {user && (user.type === 1 || user.type === 2) && (
          <div className="sidebar-nav-item-container">
            <button
              className={`sidebar-nav-item ${masterSubmenuOpen ? 'submenu-open' : ''} ${masterGroupActive && !masterSubmenuOpen ? 'group-active' : ''}`}
              onClick={handleMasterToggle}
            >
              <span>X - Master</span>
              <span className={`submenu-arrow ${masterSubmenuOpen ? 'open' : ''}`}>▼</span>
            </button>

            <div className={`sidebar-submenu ${masterSubmenuOpen ? 'open' : ''}`}>
              {user.type === 1 && (
                <a
                  className={`sidebar-submenu-item ${isActive('/MasterCharacter') ? 'sidebar-submenu-item-active' : ''}`}
                  href="/MasterCharacter"
                >
                  X1 - AI Character
                </a>
              )}
              <a
                className={`sidebar-submenu-item ${isActive('/MasterAdditionalContent') ? 'sidebar-submenu-item-active' : ''}`}
                href="/MasterAdditionalContent"
              >
                X2 - Content Configuration
              </a>
              <a
                className={`sidebar-submenu-item ${isActive('/MasterOpening') ? 'sidebar-submenu-item-active' : ''}`}
                href="/MasterOpening"
              >
                X3 - First Message Control
              </a>
              <a
                className={`sidebar-submenu-item ${isActive('/SpecialReplyPage') ? 'sidebar-submenu-item-active' : ''}`}
                href="/SpecialReplyPage"
              >
                X5 - Keyword-triggered Reply
              </a>
              <a
                className={`sidebar-submenu-item ${isActive('/FollowUpPage') ? 'sidebar-submenu-item-active' : ''}`}
                href="/FollowUpPage"
              >
                X6 - Follow Up Control
              </a>
			  <a
                className={`sidebar-submenu-item ${isActive('/BranchPage') ? 'sidebar-submenu-item-active' : ''}`}
                href="/BranchPage"
              >
                X7 - Branch
              </a>
            </div>
          </div>
        )}

        {/* Y - User Control: type 1 & 2 */}
        {user && (user.type === 1 || user.type === 2) && (
          <a
            className={`sidebar-nav-item ${isActive('/UserPage') ? 'sidebar-nav-item-current' : ''}`}
            href="/UserPage"
          >
            Y - User Control
          </a>
        )}

        {/* Z - Logout: all users — stays as button, runs async logic */}
        <button className="sidebar-nav-item logout" onClick={handleLogout}>
          Z - Logout
        </button>

      </nav>
    </div>
  );
};

export default Sidebar;